import { motion, useTransform, type MotionValue } from "motion/react";
import { Scan } from "lucide-react";
import { PhoneMockup } from "@/landing/components/PhoneMockup";

type Props = {
  scrollYProgress: MotionValue<number>;
};

/** Hooks must run here — not inline inside parent JSX. */
export function RotatingPhone({ scrollYProgress }: Props) {
  const rotateY = useTransform(scrollYProgress, [0, 1], [0, 360]);

  return (
    <motion.div style={{ rotateY }}>
      <PhoneMockup>
        <div className="flex h-full items-center justify-center bg-gradient-to-br from-[#4CAF50] to-[#45a049]">
          <motion.div
            animate={{
              scale: [1, 1.1, 1],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
            }}
          >
            <Scan className="h-32 w-32 text-white" />
          </motion.div>
        </div>
      </PhoneMockup>
    </motion.div>
  );
}
